import React from "react";

export const ZONE = {
  green: { label: "Green", cls: "text-bull border-bull/50 bg-[rgba(34,197,94,0.08)]", dot: "bg-[#22c55e]" },
  yellow: { label: "Yellow", cls: "text-[#eab308] border-[#eab308]/50 bg-[rgba(234,179,8,0.08)]", dot: "bg-[#eab308]" },
  red: { label: "Red", cls: "text-bear border-bear/50 bg-[rgba(239,68,68,0.08)]", dot: "bg-[#ef4444]" },
};

export function ZoneBadge({ zone, testid }) {
  const z = ZONE[zone];
  if (!z) return <span className="text-[11px] text-slate-500 border border-[color:var(--border-subtle)] px-2 py-0.5" data-testid={testid}>No data</span>;
  return <span className={`inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider border px-2 py-0.5 ${z.cls}`} data-testid={testid}><span className={`w-1.5 h-1.5 rounded-full ${z.dot}`} />{z.label}</span>;
}

const PARTS = [["pick", "Lead pick", 25], ["followup", "Follow-up", 25], ["interest", "Interested", 20], ["conversion", "Converted", 20], ["activity", "Activity", 10]];

export function ScoreBars({ parts = {} }) {
  return (
    <div className="space-y-1.5">
      {PARTS.map(([k, l, max]) => (
        <div key={k} className="flex items-center gap-2 text-[11px]">
          <span className="w-20 text-slate-500 shrink-0">{l}</span>
          <div className="flex-1 h-1.5 bg-white/5"><div className="h-full bg-gold transition-[width] duration-700" style={{ width: `${((parts[k] || 0) / max) * 100}%` }} /></div>
          <span className="w-10 text-right font-mono text-slate-300">{parts[k] ?? 0}/{max}</span>
        </div>
      ))}
    </div>
  );
}

export const metricLabel = { brokerage: "Brokerage ($)", active_accounts: "Active accounts", on_time_pick: "On-time pick %", score: "Avg score" };
